export const WHATSAPP_MESSAGE =
  "Ciao Chiara, ho letto la pagina di Donna Virtuosa e mi sono riconosciuta in alcune cose. Vorrei capire meglio come funziona il percorso 1:1 e se può essere adatto alla situazione che sto vivendo.";

export const WHATSAPP_URL = `https://wa.me/35677149906?text=${encodeURIComponent(
  WHATSAPP_MESSAGE,
)}`;

export const INSTAGRAM_URL = "https://www.instagram.com/chiaraperrone_._/";

export const NAV_ITEMS = [
  { label: "Il Metodo", hash: "#metodo", testid: "nav-link-metodo" },
  { label: "Chiara", hash: "#chiara", testid: "nav-link-chiara" },
  { label: "Il Percorso", hash: "#percorso", testid: "nav-link-percorso" },
  { label: "FAQ", hash: "#faq", testid: "nav-link-faq" },
];

export const scrollToHash = (hash) => {
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -80, duration: 1.4 });
  } else {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }
};
